module.exports = __webpack_public_path__ + "static/media/profile-cover.98b4ed50.jpg";